// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"325":"e3863c42","691":"4790d368","828":"4790d368","892":"4790d368"}[chunkId] + ".chunk.css";
};